import { useCompanyId } from '@startuptools/common/react-wrapper';
import { useSnrCasesSuspenseQuery } from '../../../graphql/react-operations';
import { Card } from '@startuptools/ui/Card';
import { DateFormat } from '@startuptools/ui/DateFormat';
import { Table } from '@startuptools/ui/Table';
import { Typography } from '@startuptools/ui/Typography';
import { Trans, useLingui } from '@lingui/react';
import { SnrFilingLink } from './SnrFilingLink';

export const SnrCases = () => {
  const companyId = useCompanyId();
  const { i18n } = useLingui();
  const { data } = useSnrCasesSuspenseQuery({ variables: { companyId } });

  return (
    <Card>
      <Table sx={{ tableLayout: 'auto' }}>
        <thead>
          <tr>
            <th>
              <Trans id="Registration Date" />
            </th>
            <th>
              <Trans id="Arrived at" />
            </th>
            <th>
              <Trans id="Subjects" />
            </th>
            <th>
              <Trans id="Status" />
            </th>
            <th align="right">
              <Trans id="Filing Number" />
            </th>
          </tr>
        </thead>
        <tbody>
          {data.snrCases.models.map(c => {
            return (
              <tr key={c.id}>
                <td>{c.registrationDate && <DateFormat locale={i18n.locale}>{c.registrationDate}</DateFormat>}</td>
                <td>{c.arrivalDate && <DateFormat locale={i18n.locale}>{c.arrivalDate}</DateFormat>}</td>
                <td>
                  {c.subjects.map(s => (
                    <Typography key={s.value}>{s.value}</Typography>
                  ))}
                </td>
                <td>
                  {c.status.map(s => (
                    <Typography key={s.value}>{s.value}</Typography>
                  ))}
                </td>
                <td align="right">
                  <SnrFilingLink filingYear={c.filingYear} filingNumber={c.filingNumber} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Card>
  );
};
